import { Group } from '@mantine/core'
import React, { ReactElement, useEffect } from 'react'

import useFieldState from '../../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import useFieldValue from '../../../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import ReadonlyInput, {
  TReadonlyInputProps,
} from '../../../../../../../../1stlog-ui/src/components/Input/ReadonlyInput'
import { formatDecimalNumber } from '../../../../../../../../1stlog-ui/src/utils/format'
import { getVolume } from '../../../../../../../helpers/measurementHelpers'

type ReadonlyVolumeProps = {
  readonly?: boolean
} & TReadonlyInputProps

export const ReadonlyVolume = (props: ReadonlyVolumeProps): ReactElement => {
  const { readonly, ...rest } = props

  const [allowCustomVolume] = useFieldState('allowCustomVolume')

  const height = useFieldValue<number>('height')
  const width = useFieldValue<number>('width')
  const length = useFieldValue<number>('length')

  const [volume, setVolume] = useFieldState('volume')

  useEffect(() => {
    if (allowCustomVolume) {
      return
    }
    setVolume(getVolume({ height, width, length }))
  }, [height, width, length])

  return (
    <div>
      <Group
        position="center"
        spacing="xs"
        className={readonly ? 'mt-0' : 'mt-1'}
      >
        <ReadonlyInput
          {...rest}
          format={(v) =>
            `${formatDecimalNumber(parseFloat(String(volume)), 0, 3)} m³`
          }
          bolder
        />
        {/* <Tooltip label={i18n.t('edit_volume', 'Volumen manuell anpassen')}>
          <ActionIcon
            variant="transparent"
            color="blue"
            onClick={() => setAllowCustomVolume(true)}
          >
            <FontAwesomeIcon icon={faEdit} size="sm" />
          </ActionIcon>
        </Tooltip> */}
      </Group>
    </div>
  )
}
